import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import TagManager from "react-gtm-module";
import Logo1 from "../assets/Medal.png";
import Logo2 from "../assets/Crown.png";
import Logo3 from "../assets/Diamond.png";
import Phonelogo1 from "../assets/PremiumPhone1.png";
import Phonelogo2 from "../assets/PremiumPhone2.png";
import { useInView } from "react-intersection-observer";

const gtmId = "GTM-T4QRDGLB";
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};

const Subscription = ({ openContactInfo }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [hovered, setHovered] = useState({
    id: "sub1",
    featureText: "Regular Features",
  });
  const [animationState, setAnimationState] = useState(false);

  useEffect(() => {
    initializeTagManager();
    setAnimationState(true);

    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      setIsMobile(/android|iphone|ipad|ipod/i.test(userAgent));
    };

    // Initial mobile check
    checkIfMobile();

    // Event listeners
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const handleMouseEnter = (id, featureText) => {
    setHovered({ id, featureText });
  };

  const handleMouseLeave = () => {
    setHovered({ id: "sub1", featureText: "Regular Features" });
  };

  const getTitle = (id, defaultText) => {
    if (hovered && hovered.id === id) {
      return hovered.featureText;
    }
    return defaultText;
  };

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const growVariants = {
    rest: { scale: 1 },
    hover: {
      scale: 1.1,
      transition: {
        duration: 0.3,
      },
    },
  };

  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });

  return (
    <motion.div
      className="Subscription-container"
      id="subscription"
      initial="hidden"
      animate={animationState ? "visible" : "hidden"}
      variants={containerVariants}
    >
      <h1>BUSINESS SUBSCRIPTIONS</h1>
      <div className="Subscription-Section">
        {/* First Box */}
        <motion.div
          ref={ref1}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={inView1 ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8 }}
          className={`grow sub1 ${
            hovered && hovered.id === "sub1" ? "hover" : ""
          }`}
          id="sub1"
          onMouseEnter={() => handleMouseEnter("sub1", "Regular Features")}
          onMouseLeave={handleMouseLeave}
          variants={growVariants}
          whileHover="hover"
        >
          <h2>{getTitle("sub1", "Regular")}</h2>
          <motion.div
            className="subscription-content"
            initial={{ opacity: 0, y: 20 }}
            animate={hovered.id === "sub1" ? { opacity: 1, y: 10 } : {}}
            transition={{ type: "spring", stiffness: 300 }}
            style={{ marginTop: "21%" }}
          >
            <ol className="SubList2">
              <li>Appointment Number</li>
            </ol>
            <ol className="SubList1" style={{ marginTop: "0%" }}>
              <li>Calendar Access</li>
              <li>Limited Offers And Deals</li>
              <li>24/7 Support</li>
            </ol>
          </motion.div>

          <div className="IconContainer" style={{ backgroundColor: "#969471" }}>
            <img
              src={Logo1}
              width="55px"
              height="54px"
              style={{ scale: "0.8" }}
              alt=""
            />
          </div>
          {/* <div className="PriceContainer">29$</div>
          {hovered && hovered.id === "sub1" && (
            <div className="MiniPrice">
              <h3>29$</h3>
              <p>{"//Month"}</p>
            </div>
          )} */}
        </motion.div>
        {/* Second Box */}
        <motion.div
          ref={ref2}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={inView2 ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 1 }}
          className={`grow sub2 ${
            hovered && hovered.id === "sub2" ? "hover" : ""
          }`}
          id="sub2"
          onMouseEnter={() => handleMouseEnter("sub2", "Business Features")}
          onMouseLeave={handleMouseLeave}
          variants={growVariants}
          whileHover="hover"
        >
          <h2>{getTitle("sub2", "Business")}</h2>
          <motion.div
            className="subscription-content"
            initial={{ opacity: 0, y: 20 }}
            animate={hovered.id === "sub2" ? { opacity: 1, y: 0 } : {}}
            transition={{ type: "spring", stiffness: 300 }}
            style={{ marginTop: "21%" }}
          >
            <ol className="SubList1">
              <li>All Regular Features</li>
              <li
                className="SubscriptionPlus"
                style={{
                  textAlign: "start",
                  scale: "1.2",
                  fontWeight: "bolder",
                  margin: "0px 0 0px 0 ",
                  left: "9.5%",
                  fontSize: "24px",
                }}
              >
                {" "}
                +{" "}
              </li>
              <li>Offers And Deals</li>
              <li>Access to App Advertisement</li>
              <li>Insights and Reports</li>
            </ol>
          </motion.div>
          <div className="IconContainer" style={{ backgroundColor: "#969471" }}>
            <img
              src={Logo2}
              width="55px"
              height="54px"
              style={{ scale: "0.8" }}
              alt=""
            />
          </div>
          {/* <div className="PriceContainer">49$</div> */}
          {/* {hovered && hovered.id === "sub2" && (
            <div className="MiniPrice">
              <h3>49$</h3>
              <p>{"//Month"}</p>
            </div>
          )} */}
        </motion.div>
        {/* Third Box */}
        <motion.div
          ref={ref3}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={inView3 ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 1.2 }}
          className={`grow sub3 ${
            hovered && hovered.id === "sub3" ? "hover" : ""
          }`}
          id="sub3"
          onMouseEnter={() => handleMouseEnter("sub3", "Premium Features")}
          onMouseLeave={handleMouseLeave}
          variants={growVariants}
          whileHover="hover"
        >
          <h2>{getTitle("sub3", "Premium")}</h2>
          <motion.div
            className="subscription-content"
            initial={{ opacity: 0, y: 20 }}
            animate={hovered.id === "sub3" ? { opacity: 1, y: 15 } : {}}
            transition={{ type: "spring", stiffness: 300 }}
            style={{ marginTop: "12%" }}
          >
            <ol className="SubList1">
              <li>All Business Features</li>
              <li
                className="SubscriptionPlus"
                style={{
                  textAlign: "start",
                  scale: "1.2",
                  fontWeight: "bolder",
                  margin: "0px 0 0px 0 ",
                  left: "10%",
                  fontSize: "24px",
                }}
              >
                {" "}
                +{" "}
              </li>
              <li>Customizable App Features</li>
              <li>Advanced Insights And Reports</li>
              <li>Premium App Advertisement</li>
            </ol>
          </motion.div>
          <div className="PriceContainer">
            <img
              src={Phonelogo1}
              width={32}
              height={32}
              alt=""
              style={{ transform: "scale(1.3)" }}
            />
          </div>
          <div className="IconContainer" style={{ backgroundColor: "#3b8580" }}>
            <img
              src={Logo3}
              width="55px"
              height="54px"
              style={{ scale: "0.8" }}
              alt=""
            />
          </div>
          {hovered && hovered.id === "sub3" && (
            <>
              {isMobile ? (
                <div
                  className="MiniPrice MiniPriceSub3"
                  onClick={() => window.open(`tel:+96176624565`)}
                >
                  <img src={Phonelogo2} width={32} height={32} alt="" />
                </div>
              ) : (
                <div
                  className="MiniPrice MiniPriceSub3"
                  onClick={() => openContactInfo(true)}
                >
                  <img src={Phonelogo2} width={32} height={32} alt="" />
                </div>
              )}
            </>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Subscription;
